
/**
 * Search for "Note:" th tag and add class "hidden". The "Note:" content will be
 * displayed below the "Order received" main order-details table.
 */
(function(){
    var table = document.querySelector('table.woocommerce-table--order-details');
    if (!table) return;
    var thTags = table.getElementsByTagName('th');
    var searchText = 'Note:', th;
    for (var i = 0; i < thTags.length; i++) {
        console.log(thTags[i].textContent);
        if ('Note:' == thTags[i].textContent) {
            th = thTags[i];
            break;
        }
    }
    if (th) th.closest('tr').classList.add('hidden');
})();

/*
(function($){

    //$( document.body ).trigger( 'updated_checkout', [ data ] );

    console.log(document.body);

    document.body.addEventListener('updated_checkout', function(e, data){
        console.log('js-event');
        console.log(e);
        console.log(data);
    }, false);

    $( document.body ).on('updated_checkout', function(e,data){
        console.log('jquery-event');
        console.log(e);
        console.log(data);

        console.log($('input[name="shipping_method\[0\]"]'));
    })
})(jQuery);


if (0) {
    (function(){
        alert('ok');
    })();
}
*/
